var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { SpaAuth } from '@resmed/identity-spa-auth-js';
import { environmentConfig } from 'environmentConfig';
import { logger } from 'utils/logger';
const verboseHttpLogEnvs = ['local', 'dev-dit-amr', 'dev-fit-amr'];
const isVerboseHttpLoggingEnv = verboseHttpLogEnvs.includes(environmentConfig.env);
export const axiosClient = axios.create({
    baseURL: environmentConfig.userServiceUrl
});
axiosClient.defaults.withCredentials = true;
axiosClient.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (isVerboseHttpLoggingEnv) {
        logger.debug('HTTP request started', {
            method: (_a = config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            url: config.url
        });
    }
    config.headers['Rmd-Client-Id'] = environmentConfig.oktaClientId;
    // Get SpaAuth instance once for this request
    let auth = null;
    try {
        auth = SpaAuth.get();
    }
    catch (_b) {
        // Not initialized, skip auth-related headers
        return config;
    }
    // Get user ID from claims for local development
    if (environmentConfig.env === 'local') {
        try {
            const claims = yield auth.getClaims();
            if (claims === null || claims === void 0 ? void 0 : claims.subject) {
                config.headers['Rmd-User-Id'] = claims.subject;
            }
        }
        catch (_c) {
            // Not authenticated, skip header
        }
    }
    // Add CSRF token for mutating requests
    if (config.method && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(config.method.toUpperCase())) {
        const csrfToken = auth.getCsrfToken();
        if (csrfToken) {
            config.headers['X-CSRF-TOKEN'] = csrfToken;
        }
    }
    return config;
}), (error) => {
    logger.error('HTTP request interceptor error', { error });
    if (error instanceof Error) {
        return Promise.reject(error);
    }
    return Promise.reject(new Error(String(error)));
});
axiosClient.interceptors.response.use((response) => {
    var _a, _b, _c;
    if (isVerboseHttpLoggingEnv) {
        logger.debug('HTTP response received', {
            method: (_b = (_a = response.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
            url: (_c = response.config) === null || _c === void 0 ? void 0 : _c.url,
            status: response.status
        });
    }
    return response;
}, (error) => {
    var _a, _b;
    const config = error === null || error === void 0 ? void 0 : error.config;
    const status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
    const context = {
        method: (_b = config === null || config === void 0 ? void 0 : config.method) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
        url: config === null || config === void 0 ? void 0 : config.url,
        status
    };
    if (error instanceof Error) {
        context.errorName = error.name;
        context.errorMessage = error.message;
        context.errorStack = error.stack;
    }
    else if (error !== undefined) {
        context.rawError = String(error);
    }
    logger.error('HTTP response error', context);
    return Promise.reject(error);
});
